import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from 'environments/environment.prod';
import { map } from 'rxjs/operators/map';

@Injectable()
export class WebServiceService {

  barCodeValue = 509;
  bookingCount: any;
  baseUrl: any = 'https://lotus.ruzinn.com/dshbrd/';
  selectedGroupItem: any;
  constructor(public http: HttpClient,) {
    this.bookingCount = sessionStorage.getItem('count');
  }
  setbookingCount(value) {
    this.bookingCount = value;
  }
  httpPost(api, datatosend): Observable<any> {

    var token = JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];
    // var userId=JSON.parse(sessionStorage.getItem('currentUser')).user_id
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        // 'User_Id':userId,
        'Auth-Token': token
      })
    };
    return this.http.post(environment.baseUrl + api, datatosend, httpOptions);
  }
  httpLoginPost(api, datatosend): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json'
      })
    };
    return this.http.post(environment.baseUrl + api, datatosend, httpOptions);
  }
  httpPut(api, datatosend): Observable<any> {

    var token = JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];
    // var userId=JSON.parse(sessionStorage.getItem('currentUser')).user_id
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        // 'User_Id':userId,
        'Auth-Token': token
      })
    };
    return this.http.put(environment.baseUrl + api, datatosend, httpOptions);
  }
  httploginGet(api) {
    return this.http.get(environment.baseUrl + api)
  }
  httpGet(api) {
    var token = JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];
    // var userId=JSON.parse(sessionStorage.getItem('currentUser')).user_id
    const httpOptions = {
      headers: new HttpHeaders({
        // 'User_Id':userId,
        'Auth-Token': token
      })
    };
    return this.http.get(environment.baseUrl + api, httpOptions)
  }
  httpGetWithoutSecure(api) {

    return this.http.get(environment.baseUrl + api)
  }
  httpDsbrdGet(api) {
    var token = JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];
    const httpOptions = {
      headers: new HttpHeaders({
        'Auth-Token': token
      })
    };
    return this.http.get(this.baseUrl + api, httpOptions)
  }
  // httpdownload(api){
  //   var token=JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];
  // const httpOptions = {
  //   headers : new HttpHeaders({
  //     'Auth-Token':token
  //   })
  // };
  //   return this.http.get(environment.baseUrl+api,httpOptions)
  // }

  getDropdownList(api) {

    var token = JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];
    // var userId=JSON.parse(sessionStorage.getItem('currentUser')).user_id
    const httpOptions = {
      headers: new HttpHeaders({
        'content-type': 'application/json',
        // 'User_Id':userId,
        'Auth-Token': token
      })
    };
    return this.http.get(environment.baseUrl + '/lists/' + api, httpOptions);
  }
  httpdownload(api) {
    var token = JSON.parse(sessionStorage.getItem('currentUser'))['Auth-token'];

    const headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Auth-Token': token, responseType: 'blob' });

    return this.http.get<Blob>(environment.baseUrl + api, { headers: headers, responseType: 'blob' as 'json' });
  }


}



// WEBPACK FOOTER //
// ./src/app/web-service.service.ts